// extracted by mini-css-extract-plugin
export var container = "_sn-0";
export var dotAnimation = "_sn-2";
export var dotsLoading = "_sn-1";